'use client';

function time_convert(num) {
  var hours = Math.floor(num / 60);
  var minutes = num % 60;
  return hours + 'h ' + minutes + 'm';
}

const EnhancedCompactTableHeader = ({
  total_estimated_time,
  total_actual_time,
  total_activitys,
  statusCounts = {}, // Accept statusCounts prop
}) => {
  console.log('statusCounts', statusCounts);

  const calculateEfficiencyRate = () => {
    if (total_estimated_time === 0) return 0;
    // Calculate efficiency: if actual time is less than or equal to estimated, it's good
    // If actual time exceeds estimated, efficiency decreases
    const efficiency = Math.min(
      100,
      Math.round((total_estimated_time / total_actual_time) * 100)
    );
    return isNaN(efficiency) ? 0 : efficiency;
  };

  const getEfficiencyColor = (rate) => {
    if (rate >= 90) return 'success'; // Green - Very efficient
    if (rate >= 70) return 'warning'; // Orange - Moderately efficient
    return 'danger'; // Red - Inefficient
  };

  const efficiencyRate = calculateEfficiencyRate();
  const rateColor = getEfficiencyColor(efficiencyRate);

  // Status display order and icons
  const statusDisplay = [
    {
      key: 'PENDING',
      label: 'Pending',
      icon: 'fa-hourglass-half',
      color: '#ffc107',
    },
    {
      key: 'COMPLETED',
      label: 'Completed',
      icon: 'fa-check',
      color: '#28a745',
    },
    {
      key: 'ON-HOLD',
      label: 'On-Hold',
      icon: 'fa-pause-circle',
      color: '#17a2b8',
    },

    {
      key: 'Overdue',
      label: 'Overdue',
      icon: 'fa-exclamation-triangle',
      color: '#dc3545',
    },
  ];

  return (
    <>
      <div className='modern-table-header'>
        {/* Top Action Bar */}

        {/* Enhanced Stats Cards */}
        {/* <div className='modern-stats-row'>
          <div className='modern-stat-item'>
            <div className='modern-stat-card modern-stat-primary'>
              <div className='modern-stat-icon-wrapper'>
                <i className='fas fa-clock modern-stat-icon'></i>
              </div>
              <div className='modern-stat-content'>
                <div className='modern-stat-label'>EST. TIME</div>
                <div className='modern-stat-value'>
                  {time_convert(total_estimated_time)}
                </div>
              </div>
            </div>
          </div>

          <div className='modern-stat-item'>
            <div className='modern-stat-card modern-stat-success'>
              <div className='modern-stat-icon-wrapper'>
                <i className='fas fa-check-circle modern-stat-icon'></i>
              </div>
              <div className='modern-stat-content'>
                <div className='modern-stat-label'>ACT. TIME</div>
                <div className='modern-stat-value'>
                  {time_convert(total_actual_time)}
                </div>
              </div>
            </div>
          </div>

          <div className={`modern-stat-item`}>
            <div className={`modern-stat-card modern-stat-${rateColor}`}>
              <div className='modern-stat-icon-wrapper'>
                <i className='fas fa-chart-line modern-stat-icon'></i>
              </div>
              <div className='modern-stat-content'>
                <div className='modern-stat-label'>EFFICIENCY</div>
                <div className='modern-stat-value'>{efficiencyRate}%</div>
              </div>
            </div>
          </div>
        </div> */}

        {/* Status Counts Row */}
        <div className='modern-stats-row modern-status-row'>
          {statusDisplay.map((status) => (
            <div className='modern-stat-item' key={status.key}>
              <div
                className={`modern-stat-card`}
                style={{ borderColor: status.color }}
              >
                <div
                  className='modern-stat-icon-wrapper'
                  style={{
                    background:
                      status.key === 'PENDING'
                        ? 'linear-gradient(135deg, #ffc107, #e0a800)'
                        : status.key === 'COMPLETED'
                        ? 'linear-gradient(135deg, #28a745, #1e7e34)'
                        : 'linear-gradient(135deg, #17a2b8, #138496)',
                  }}
                >
                  <i className={`fas ${status.icon} modern-stat-icon`}></i>
                </div>
                <div className='modern-stat-content'>
                  <div className='modern-stat-label'>{status.label}</div>
                  <div
                    className='modern-stat-value'
                    style={{ color: status.color }}
                  >
                    {statusCounts[status.key] ?? 0}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style jsx>{`
        .modern-table-header {
          padding: 20px !important;
          background: #fff !important;
          border-radius: 12px !important;
          margin-bottom: 20px !important;
        }

        .modern-action-bar {
          display: flex !important;
          justify-content: space-between !important;
          align-items: center !important;
          margin-bottom: 20px !important;
          flex-wrap: wrap !important;
          gap: 15px !important;
        }

        .modern-action-left,
        .modern-action-right {
          display: flex !important;
          align-items: center !important;
        }

        .modern-button-group {
          display: flex !important;
          gap: 10px !important;
          align-items: center !important;
        }

        .modern-btn {
          display: inline-flex !important;
          align-items: center !important;
          padding: 8px 16px !important;
          border-radius: 8px !important;
          font-size: 12px !important;
          font-weight: 500 !important;
          text-decoration: none !important;
          transition: all 0.3s ease !important;
          border: none !important;
          cursor: pointer !important;
        }

        .modern-btn-danger {
          background: linear-gradient(135deg, #e41d2e, #c82333) !important;
          color: #fff !important;
        }

        .modern-btn-danger:hover {
          background: linear-gradient(135deg, #c82333, #a71e2a) !important;
          transform: translateY(-1px) !important;
          color: #fff !important;
          text-decoration: none !important;
        }

        .modern-btn-secondary {
          background: linear-gradient(135deg, #6c757d, #545b62) !important;
          color: #fff !important;
        }

        .modern-btn-secondary:hover {
          background: linear-gradient(135deg, #545b62, #495057) !important;
          transform: translateY(-1px) !important;
          color: #fff !important;
          text-decoration: none !important;
        }

        .modern-btn-info {
          background: transparent !important;
          color: #4285f4 !important;
          border: 1px solid #4285f4 !important;
        }

        .modern-btn-info:hover {
          background: rgba(66, 133, 244, 0.05) !important;
          transform: translateY(-1px) !important;
          color: #3367d6 !important;
          text-decoration: none !important;
          border-color: #3367d6 !important;
        }

        .modern-btn-primary {
          background: transparent !important;
          color: #4267b2 !important;
          border: 1px solid #4267b2 !important;
        }

        .modern-btn-primary:hover {
          background: rgba(66, 103, 178, 0.05) !important;
          transform: translateY(-1px) !important;
          color: #365899 !important;
          text-decoration: none !important;
          border-color: #365899 !important;
        }

        .modern-btn-icon {
          margin-right: 6px !important;
          font-size: 11px !important;
        }

        .modern-stats-row {
          display: grid !important;
          grid-template-columns: repeat(
            auto-fit,
            minmax(200px, 1fr)
          ) !important;
          gap: 15px !important;
        }

        .modern-stat-item {
          flex: 1 !important;
        }

        .modern-stat-card {
          background: #fff !important;
          border-radius: 10px !important;
          padding: 16px !important;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
          border: 1px solid #e9ecef !important;
          display: flex !important;
          align-items: center !important;
          gap: 12px !important;
          transition: all 0.3s ease !important;
          height: 70px !important;
        }

        .modern-stat-card:hover {
          transform: translateY(-2px) !important;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.12) !important;
        }

        .modern-stat-icon-wrapper {
          width: 40px !important;
          height: 40px !important;
          border-radius: 10px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          flex-shrink: 0 !important;
        }

        .modern-stat-primary .modern-stat-icon-wrapper {
          background: linear-gradient(135deg, #007bff, #0056b3) !important;
        }

        .modern-stat-success .modern-stat-icon-wrapper {
          background: linear-gradient(135deg, #28a745, #1e7e34) !important;
        }

        .modern-stat-info .modern-stat-icon-wrapper {
          background: linear-gradient(135deg, #17a2b8, #138496) !important;
        }

        .modern-stat-icon {
          font-size: 16px !important;
          color: #fff !important;
        }

        .modern-stat-content {
          flex: 1 !important;
          min-width: 0 !important;
        }

        .modern-stat-label {
          font-size: 10px !important;
          color: #6c757d !important;
          font-weight: 600 !important;
          margin-bottom: 4px !important;
          letter-spacing: 0.5px !important;
          text-transform: uppercase !important;
        }

        .modern-stat-value {
          font-size: 16px !important;
          font-weight: 700 !important;
          color: #212529 !important;
          line-height: 1 !important;
        }

        .modern-stat-primary .modern-stat-value {
          color: #007bff !important;
        }

        .modern-stat-success .modern-stat-value {
          color: #28a745 !important;
        }

        .modern-stat-info .modern-stat-value {
          color: #17a2b8 !important;
        }

        .modern-stat-warning .modern-stat-icon-wrapper {
          background: linear-gradient(135deg, #ffc107, #e0a800) !important;
        }

        .modern-stat-danger .modern-stat-icon-wrapper {
          background: linear-gradient(135deg, #dc3545, #c82333) !important;
        }

        .modern-stat-warning .modern-stat-value {
          color: #ffc107 !important;
        }

        .modern-stat-danger .modern-stat-value {
          color: #dc3545 !important;
        }

        .modern-status-row {
          display: grid !important;
          grid-template-columns: repeat(
            auto-fit,
            minmax(200px, 1fr)
          ) !important;
          gap: 15px !important;
          margin-top: 15px !important;
        }
        @media (max-width: 768px) {
          .modern-action-bar {
            flex-direction: column !important;
            align-items: stretch !important;
          }

          .modern-action-left,
          .modern-action-right {
            justify-content: center !important;
          }

          .modern-stats-row {
            grid-template-columns: 1fr !important;
          }

          .modern-stat-card {
            height: 65px !important;
            padding: 12px !important;
          }

          .modern-stat-icon-wrapper {
            width: 35px !important;
            height: 35px !important;
          }

          .modern-stat-icon {
            font-size: 14px !important;
          }

          .modern-stat-value {
            font-size: 14px !important;
          }

          .modern-status-row {
            flex-direction: column !important;
            gap: 6px !important;
          }
          .modern-status-card {
            padding: 7px 10px !important;
          }
          .modern-status-icon-wrapper {
            width: 22px !important;
            height: 22px !important;
          }
          .modern-status-icon {
            font-size: 11px !important;
          }
          .modern-status-value {
            font-size: 11px !important;
          }
        }
      `}</style>
    </>
  );
};

export default EnhancedCompactTableHeader;
